import { useMemo } from "react";
import { Pressable, StyleSheet, Text } from "react-native";

import { fontFamily } from "@passfirst/ui";

import { type Colors, useColors } from "../theme";

interface Props {
  label: string;
  selected: boolean;
  onPress: () => void;
}

// Single chip in the 2-col state grid. Selected state adopts the 2px
// navy border + brand-soft fill shared with welcome's CredentialRow.
export function StateChip({ label, selected, onPress }: Props): JSX.Element {
  const colors = useColors();
  const styles = useMemo(() => makeStyles(colors), [colors]);
  return (
    <Pressable
      onPress={onPress}
      accessibilityRole="radio"
      accessibilityState={{ selected }}
      accessibilityLabel={label}
      style={[styles.chip, selected && styles.chipSelected]}
    >
      <Text style={[styles.text, selected && styles.textSelected]}>
        {label}
      </Text>
    </Pressable>
  );
}

function makeStyles(colors: Colors) {
  return StyleSheet.create({
    chip: {
      minWidth: "48%",
      flexGrow: 1,
      padding: 14,
      borderWidth: 1,
      borderColor: colors.border,
      borderRadius: 12,
      backgroundColor: colors.surface,
    },
    chipSelected: {
      borderColor: colors.borderPicked,
      borderWidth: 2,
      padding: 13,
      backgroundColor: colors.surfacePicked,
    },
    text: {
      fontFamily: fontFamily.semiBold,
      fontSize: 15,
      color: colors.textPrimary,
    },
    textSelected: { color: colors.accentSoftText },
  });
}
